import React, { useState } from "react";
import { BrowserRouter, Route, Routes, Navigate } from "react-router-dom";
import Home from "./Home";
import Login from "./pages/Login";
import SideNav from "./pages/SideNav";
import AssignedObligations from "./pages/AssignedObligations";
import CompletedObligation from "./pages/CompletedObligation";
import ViewObligation from "./pages/ViewObligation";
import CreateNewObligation from "./pages/CreateNewObligation";
import DocsLocker from "./pages/DocsLocker";
import ViewAgreement from "./pages/ViewAgreement";
import TeamManager from "./pages/TeamManager";
import ViewBu from "./pages/ViewBu";
import DashboardCompliance from "./pages/DashboardCompliance";
import OverDueCompliance from "./pages/OverDueCompliance";
import Notifications from "./pages/Notifications";
import ViewMasterObligation from "./pages/ViewMasterObligation";
import ActionedObligations from "./pages/ActionedObligations";
import Acceptobligation from "./pages/AcceptObligation";
import "./App.css";

const App = () => {
  const [userData, setUserData] = useState(null);

  return (
    <Home setUserData={setUserData}>
      <BrowserRouter>
        <Routes>
          <Route
            path="/"
            element={
              <Navigate to={userData ? "/dashboard" : "/login"} replace />
            }
          />

          {!userData ? (
            <>
              <Route path="/login" element={<Login />} />
              <Route
                path="*"
                element={
                  <Navigate
                    to={`${process.env.REACT_APP_LANDING_URL}`}
                    replace
                  />
                }
              />
            </>
          ) : (
            <>
              <Route
                path="/login"
                element={<Navigate to="/dashboard" replace />}
              />
              <Route
                path="/assigned"
                element={<SideNav appContent={<AssignedObligations />} />}
              />
              <Route
                path="/acceptobligation"
                element={<SideNav appContent={<Acceptobligation />} />}
              />
              <Route
                path="/obligationtracker"
                element={<SideNav appContent={<CompletedObligation />} />}
              />
              <Route
                path="/dashboard"
                element={<SideNav appContent={<DashboardCompliance />} />}
              />
              <Route
                path="/overdue"
                element={<SideNav appContent={<OverDueCompliance />} />}
              />
              <Route
                path="/viewobligation/:id"
                element={<SideNav appContent={<ViewObligation />} />}
              />
              <Route
                path="/new"
                element={<SideNav appContent={<CreateNewObligation />} />}
              />
              <Route
                path="/docslocker"
                element={<SideNav appContent={<DocsLocker />} />}
              />
              <Route
                path="/viewagreement/:id"
                element={<SideNav appContent={<ViewAgreement />} />}
              />
              <Route
                path="/viewbu/:id"
                element={<SideNav appContent={<ViewBu />} />}
              />
              <Route
                path="/viewmasterobligation/:id"
                element={<SideNav appContent={<ViewMasterObligation />} />}
              />
              <Route
                path="/team"
                element={<SideNav appContent={<TeamManager />} />}
              />
              <Route
                path="/notifications"
                element={<SideNav appContent={<Notifications />} />}
              />
              <Route
                path="/actioned"
                element={<SideNav appContent={<ActionedObligations />} />}
              />
              <Route path="*" element={<p>Page not found</p>} />
            </>
          )}
        </Routes>
      </BrowserRouter>
    </Home>
  );
};

export default App;
